import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiClientService } from '../service/api-client.service';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';

@Injectable()
export class HttpServiceService {
  constructor(private apiClient: ApiClientService) {}

  async searchGoogle(searchInput: string) {
    searchInput = encodeURIComponent(searchInput);
    const path = `${environment.cpmBaseUrl}/google/search?q=${searchInput}`;
    // tslint:disable-next-line:max-line-length
    return this.apiClient.getTextWithPath(path).toPromise();
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/service/http-service.service.ts